import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";

import ReusableDashboardHeader from "../../../Containers/Dasboard/ReusableDashboardHeader";
import { BackButton } from "../../../Utils/FormInputs/BackButton";
import TextField from "../../../Utils/FormInputs/TextField";
import Label from "../../../Utils/FormInputs/Label";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useMuiPagination } from "../../../Containers/Dasboard/DashboardTables";
import {
  EnhancedTableHead,
  EnhancedTableToolbar,
  MuiPagination,
  MuiPaper,
} from "../../../Utils/Tables/CustomTable";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";

import { titleCase } from "../../../Utils/titleCaseFunction";
import { dateConvert } from "../../../Utils/ConvertDate";
import { LoadingGif } from "../../../Utils/Loader";
import { ErrorMessage } from "../../../Utils/styledComponents";



const headData = [
  { id: "date", numeric: false, disablePadding: false, label: "Date" },
  { id: "product", numeric: false, disablePadding: false, label: "Product" },
  { id: "batch", numeric: false, disablePadding: false, label: "Batch #" },
  { id: "reason", numeric: false, disablePadding: false, label: "Reason" },
  { id: "quantity", numeric: true, disablePadding: false, label: "Quantity" },
  { id: "unit_cost", numeric: true, disablePadding: false, label: "Unit Cost (USh)" },
  { id: "total_cost", numeric: true, disablePadding: false, label: "Total Cost (USh)" },
  { id: "adjusted_by", numeric: false, disablePadding: false, label: "Adjusted By" },
];


const DamagedGoodsReport = () => {
    const { 
      page, 
      rowsPerPage, 
      handleChangePage, 
      handleChangeRowsPerPage,
      setPage  
    } = useMuiPagination();
  
    const today = new Date().toISOString().split('T')[0]; // "2025-12-29"
  
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalCount, setTotalCount] = useState(0);
    const [totalDamagedQty, setTotalDamagedQty] = useState(0);
    const [totalDamagedCost, setTotalDamagedCost] = useState(0);
    const [search, setSearch] = useState("");
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
  
    // Ensure dates are set even if component re-renders
    useEffect(() => {
      setFromDate(today);
      setToDate(today);
    }, []);
    
  const fetchData = () => {
    setLoading(true);
    axios
      .get(`${config.epharmUrl}/Creport/damage_list`, {
        params: {
          page: page + 1, // because backend starts at page 1, MUI starts at 0
          search: search || null,
          start_date: fromDate || null,
          end_date: toDate || null,
        },
      })
      .then((res) => {
        const resp = res.data;
        setData(resp.adjustments || []);
        setTotalCount(resp.total_count || 0);
        setTotalDamagedQty(resp.total_damaged_quantity || 0);
        setTotalDamagedCost(resp.total_damaged_cost || 0);
        setLoading(false);
      })
      .catch((err) => {
        ErrorMessage(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [page, search, fromDate, toDate]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(0);
    fetchData();
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === "from_date") setFromDate(value);
    if (name === "to_date") setToDate(value);
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length);

  return (
    <div className="journals">
      <ReusableDashboardHeader
        component="Damaged Goods Report"
        heading="Reports"
        subHeading="Damaged Goods"
        link="/reports"
      />

      <div className="general-ledger-header mb-3">
        <div className="mb-3">
          <BackButton text="Reports" to="/allreports" />
        </div>

        <form onSubmit={handleSearchSubmit}>
          <Form.Group as={Row} style={{ marginBottom: "-1%" }}>
            <Col sm={4}>
              <Form.Group as={Row}>
                <Label name="From" column sm={2} style={{ textAlign: "right" }} />
                <Col sm={10}>
                  <TextField type="date" value={fromDate} onChange={handleDateChange} name="from_date" />
                </Col>
              </Form.Group>
            </Col>

            <Col sm={4}>
              <Form.Group as={Row}>
                <Label name="To" column sm={2} />
                <Col sm={10}>
                  <TextField type="date" value={toDate} onChange={handleDateChange} name="to_date" />
                </Col>
              </Form.Group>
            </Col>

            <Col sm={3}>
              <Form.Group as={Row}>
                <Label name="Search" column sm={3} />
                <Col sm={9}>
                  <TextField
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Product, batch, reason..."
                  />
                </Col>
              </Form.Group>
            </Col>

            <Col sm={1} className="d-flex align-items-end">
              <button type="submit" className="btn btn-sm pharmacy-btn-outline">
                Filter
              </button>
            </Col>
          </Form.Group>
        </form>
      </div>

      {/* Grand Totals */}
      <div className="alert alert-warning mb-4">
        <strong>Total Damaged Quantity:</strong> {totalDamagedQty.toFixed(2)} units &nbsp;|&nbsp;
        <strong>Total Financial Loss:</strong>{" "}
        USh {totalDamagedCost.toLocaleString(undefined, { minimumFractionDigits: 2 })}
      </div>

      <div className="mui-tables">
        <MuiPaper>
          <EnhancedTableToolbar title="Damaged Goods List" />
          <TableContainer>
            <Table aria-labelledby="tableTitle" size="medium" aria-label="enhanced table">
              <EnhancedTableHead headCells={headData} />

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={headData.length} align="center">
                      <LoadingGif />
                    </TableCell>
                  </TableRow>
                ) : data.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={headData.length} align="center">
                      No damaged goods recorded in this period.
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    {data.map((item, index) => (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index} className="mui-table-row">
                        <TableCell>{dateConvert(item.date_created)}</TableCell>
                        <TableCell>{titleCase(item.product_name)}</TableCell>
                        <TableCell>{item.batch_id || "-"}</TableCell>
                        <TableCell>{titleCase(item.reason)}</TableCell>
                        <TableCell align="right">{item.quantity}</TableCell>
                        <TableCell align="right">{item.unit_cost.toLocaleString()}</TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold", color: "#c4495c" }}>
                          {item.total_cost.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </TableCell>
                        <TableCell>{titleCase(item.created_by)}</TableCell>
                      </TableRow>
                    ))}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 43 * emptyRows }}>
                        <TableCell colSpan={headData.length} />
                      </TableRow>
                    )}
                  </>
                )}
              </TableBody>
            </Table>

            <MuiPagination
              data={data}
              total_count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rows={[10, 25, 50, 100]}
              colSpan={8}
            />
          </TableContainer>
        </MuiPaper>
      </div>
    </div>
  );
};

export default DamagedGoodsReport;